import { useMemo } from 'react'

import { type User as PropelAuthUser, useAuthInfo } from '@sweetauth/core'

import { IS_PROD_LIKE_ENVIRONMENT } from '@/constants/env'

import { useViewAsCustomer } from '@/stores/DevImpersonationStore'

const INTERNAL_EMAILS = ['@sweetspot.so', 'sweetspot-test@gmail.com']

export const isInternalEmail = (email: string) => {
  // emails are case-insensitive; keep parity with the server's
  // is_sweetspot_team_email
  const lowered = email.toLowerCase()
  return INTERNAL_EMAILS.some((allowed) =>
    allowed.startsWith('@') ? lowered.endsWith(allowed) : lowered === allowed,
  )
}

export const isInternalUser = (user: PropelAuthUser | null | undefined) => {
  if (!user) return false
  return isInternalEmail(user.email)
}

export const useIsInternalUser = () => {
  const { user } = useAuthInfo()
  return useMemo(() => isInternalUser(user), [user?.email])
}

// like useIsInternalUser, but honors the dev-only "view as customer" toggle so
// internal users can test customer-facing request behavior end to end
export const useIsSweetspotTeamMember = () => {
  const isInternal = useIsInternalUser()
  const viewAsCustomer = useViewAsCustomer()
  if (IS_PROD_LIKE_ENVIRONMENT) {
    return isInternal
  }
  return isInternal && !viewAsCustomer
}
